import { render, staticRenderFns } from "./paychk_glps.vue?vue&type=template&id=87816226&scoped=true&"
import script from "./paychk_glps.vue?vue&type=script&lang=js&"
export * from "./paychk_glps.vue?vue&type=script&lang=js&"
import style0 from "./paychk_glps.vue?vue&type=style&index=0&id=87816226&scoped=true&lang=less&"
import style1 from "./paychk_glps.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87816226",
  null
  
)

export default component.exports